<template>
    <Modal
        v-model="showModal"
        title="字段说明"
        width="800"
        :mask-closable="false"
        class="column-desc-modal"
    >
        <Table :columns="columnColumns" :data="columnData" border></Table>
        <div slot="footer">
            <Button type="primary" @click="closeModal">关闭</Button>
        </div>
    </Modal>
</template>

<script>
export default {
    name: "RequestLogColumnDescModal",
    data() {
        return {
            showModal: false,
            columnColumns: [
                {
                    title: '字段名',
                    key: 'field',
                    width: 200,
                    render: (h, params) => {
                        return h('code', {
                            style: {
                                backgroundColor: '#f5f5f5',
                                padding: '2px 6px',
                                borderRadius: '3px'
                            }
                        }, params.row.field);
                    }
                },
                {
                    title: '说明',
                    key: 'description'
                },
                {
                    title: '示例',
                    key: 'example',
                    render: (h, params) => {
                        return h('code', {
                            style: {
                                backgroundColor: '#f0f9ff',
                                color: '#0369a1',
                                padding: '2px 6px',
                                borderRadius: '3px'
                            }
                        }, params.row.example);
                    }
                }
            ],
            columnData: [
                {
                    field: 'Timestamp',
                    description: '请求发生的时间戳',
                    example: '2024-01-01 12:00:00'
                },
                {
                    field: 'Method',
                    description: 'HTTP请求方法',
                    example: 'GET, POST, PUT, DELETE'
                },
                {
                    field: 'Path',
                    description: '请求的URL路径',
                    example: '/api/user/list'
                },
                {
                    field: 'ResponseStatusCode',
                    description: 'HTTP响应状态码',
                    example: '200 (成功), 404 (未找到), 500 (服务器错误)'
                },
                {
                    field: 'Duration',
                    description: '请求处理耗时（毫秒）',
                    example: '150 (表示150毫秒)'
                },
                {
                    field: 'UserId',
                    description: '发起请求的用户ID',
                    example: 'U123456789'
                },
                {
                    field: 'UserName',
                    description: '发起请求的用户名',
                    example: 'admin, zhangsan'
                },
                {
                    field: 'RemoteIpAddress',
                    description: '客户端IP地址',
                    example: '192.168.1.100'
                },
                {
                    field: 'RequestSize',
                    description: '请求体大小（字节）',
                    example: '1024'
                },
                {
                    field: 'ResponseSize',
                    description: '响应体大小（字节）',
                    example: '2048'
                }
            ]
        };
    },
    methods: {
        openColumnDescModal() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        }
    }
};
</script>

<style lang="less" scoped>
.column-desc-modal {
    /deep/ .ivu-table {
        font-size: 13px;
    }

    /deep/ .ivu-table-cell {
        padding: 8px;
    }
}
</style>